/** @format */

export const utilityDecimalHours = (hours: number, minutes: number = 0, seconds: number = 0) => {
  return hours + minutes / 60 + seconds / 3600;
};
